import { colors } from "@/app/constants/styles";
import { StyleSheet, ViewStyle } from "react-native";

export const checkboxStyles = (enabled: boolean): Record<string, ViewStyle> =>
  StyleSheet.create({
    container: {
      paddingHorizontal: 10,
      paddingVertical: 10,
    },
    checkContainer: {
      alignItems: "center",
      justifyContent: "center",
      width: 40,
      height: 40,
      backgroundColor: colors.maroon,
      borderColor: enabled ? colors.maroon : colors.dullWhite,
      borderWidth: 2,
    },
  });
